import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getPreconditionQuestionsOptions(
  params: Parameters<typeof service.getPreconditionQuestions>[number],
) {
  return queryOptions({
    queryFn: () => service.getPreconditionQuestions(params),
    queryKey: [
      'get-precondition-questions',
      params.cartGuid,
      params.customerGuid,
    ],
  });
}
